import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _jkRoomsCountSelector;

import { ERoomCount } from '../repositories/newbuilding-estimate/v1/get-newbuilding-estimation-web';

/**
 * Набор опций для селектора комнатности ЖК состоит из всех значений ERoomCount из апи
 * и дополнительно кнопки "Все"
 * */
export var ALL = 'All';
export var jkRoomsCountSelectorOptions = (_jkRoomsCountSelector = {}, _defineProperty(_jkRoomsCountSelector, ALL, {
  label: 'Все',
  selectedLabel: 'Любая комнатность',
  value: ALL
}), _defineProperty(_jkRoomsCountSelector, ERoomCount.Studio, {
  label: 'Студия',
  selectedLabel: 'Студия',
  value: ERoomCount.Studio
}), _defineProperty(_jkRoomsCountSelector, ERoomCount.OneRoom, {
  label: '1',
  selectedLabel: '1 комн.',
  value: ERoomCount.OneRoom
}), _defineProperty(_jkRoomsCountSelector, ERoomCount.TwoRoom, {
  label: '2',
  selectedLabel: '2 комн.',
  value: ERoomCount.TwoRoom
}), _defineProperty(_jkRoomsCountSelector, ERoomCount.ThreeRoom, {
  label: '3',
  selectedLabel: '3 комн.',
  value: ERoomCount.ThreeRoom
}), _defineProperty(_jkRoomsCountSelector, ERoomCount.FourRoom, {
  label: '4+',
  selectedLabel: '4+ комн.',
  value: ERoomCount.FourRoom
}), _jkRoomsCountSelector);